<div id="about-us" class="py-5 my-4">
    <div class="container">
        <div class="row">

            <!-- Heart Mind Soul Section -->
            <div class="col-12 col-md-6 col-lg-7 pe-lg-5 mb-4">
                <h2 class="h2 fw-bold text-uppercase mb-3" style="letter-spacing: -0.5px;">Education for Heart, Mind and Soul</h2>

                <p class="mb-3 lead fw-normal">
                    “Educating the mind without educating the heart is no education at all!” The above adage by Aristotle implies the importance of imparting values like empathy, compassion, resilience, rationality, humanity, accountability, integrity, confidence, and courage through education. In SSJGC we try to impart an education that extends beyond the confines of textbooks and lecture halls to nurture the holistic development of heart, mind, and soul.
                </p>
                <p class="mb-4 text-muted" style="line-height: 1.7;">
                    At our institution, we foster an environment where students not only excel in their chosen fields but also cultivate empathy, compassion, and resilience. Our comprehensive approach to education encourages students to explore their passions, engage in meaningful dialogue, and embrace diversity. Through a blend of rigorous academic programs and community service initiatives, we empower our students to become well-rounded individuals who are equipped to make a positive impact on the world.
                </p>

                <a routerLink="/about-us/our-history" class="btn btn-outline-orange px-4 py-2 fw-bold text-uppercase"
                   style="border: 2px solid var(--secondary); color: var(--secondary); border-radius: 8px; transition: all 0.3s ease;">
                    Who We Are <i class="fa-solid fa-chevron-right ms-1" style="font-size: 12px;"></i>
                </a>
            </div>

            <!-- College Showcase Image -->
            <div class="col-12 col-md-6 col-lg-5 mb-4 d-flex align-items-center">
                <div class="college-img-wrapper w-100 shadow-lg rounded-4 overflow-hidden position-relative border border-3 border-white">
                    <img src="/assets/img/home/aboutcollege.jpg" alt="Shah Satnam Ji Girls College Campus" class="img-fluid w-100 college-showcase-img">
                    <div class="img-overlay-accent"></div>
                </div>
            </div>

        </div>
    </div>
</div>